import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Input,
  FormGroup,
  FormText,
  Form,
} from "reactstrap";
import {
  Search,
  Briefcase,
  Award,
  Building,
  Star,
  ArrowRigh,
  Check,
  Gift,
  Users,
  MapPin,
} from "react-feather";
import { FaCoins } from "react-icons/fa";

const primaryColor = "#C16D18";
class BrowseJobs extends React.Component {
  render() {
    const benefits = [
      { icon: Gift, title: "Field Audits" },
      { icon: Users, title: "Part-time Jobs" },
      { icon: FaCoins, title: "Flexibility" },
      { icon: Gift, title: "Utilise Weekends" },
      { icon: Users, title: "Freelance Jobs" },
      { icon: FaCoins, title: "Earn While Studying" },
    ];
    return (
      <>
        
      <Row className="mt-4 mx-auto">
        {benefits.map((benefit, index) => (
          <Col xs={6}  md={4} key={index} className="">
            <Card className="border-0 text-center shadow-sm w-75 h-75 bannercard">
              <CardBody className="p-3 d-flex flex-column align-items-center">
                <div
                  className="d-flex justify-content-center align-items-center rounded-circle mb-3"
                  style={{
                    backgroundColor: `${primaryColor}20`,
                    width: "30px",
                    height: "60px",
                  }}
                >
                  <benefit.icon size={14} style={{ color: primaryColor }} />
                </div>
                <CardTitle
                  style={{
                    fontSize: "0.60rem",
                    color: "#383838",
                    fontWeight: "600",
                  }}
                  className="text-center"
                >
                  {benefit.title}
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      <p className="lead " style={{color:'black'}}>Help your friend with <span style={{color:primaryColor}}>Refer & Earn program</span></p>
      </>
    );
    return (
      <div className="">
        <div id="browse-jobs" className="section">
          <h4 className="text-center section-title text-dark">Why Us</h4>
          <div className="container">
            <div className="row gap-2">
              <div className="col-lg-6 col-md-12 col-sm-12 ">
                <Row className="mt-5">
                  {[
                    {
                      icon: Gift,
                      title: "Field Audits",
                      description:
                        "Create your account now before it's too late !",
                    },
                    {
                      icon: Users,
                      title: "Part time job",
                      description:
                        "Earn additional rewards for every friend who joins through your referral",
                    },
                    {
                      icon: FaCoins,
                      title: "Flexibility",
                      description:
                        "Access special promotions and milestone rewards as you grow",
                    },
                    {
                      icon: Gift,
                      title: "Utilise your Weekends",
                      description:
                        "Create your account now before it's too late !",
                    },
                    {
                      icon: Users,
                      title: "Jobs for Freelancers",
                      description:
                        "Earn additional rewards for every friend who joins through your referral",
                    },
                    {
                      icon: FaCoins,
                      title: "Earn while you study",
                      description:
                        "Access special promotions and milestone rewards as you grow",
                    },
                  ].map((benefit, index) => (
                    <Col sm={6} md={4} key={index} className="mb-4">
                      <Card className="border-0 h-100 text-center shadow hover-card">
                        <CardBody className="p-2">
                          <div
                            className="rounded-circle mx-auto mb-4 p-3 mt-2"
                            style={{
                              backgroundColor: `${primaryColor}20`,
                              width: "50px",
                              height: "50px",
                            }}
                          >
                            <benefit.icon
                              size={20}
                              style={{ color: primaryColor }}
                            />
                          </div>
                          <CardTitle
                            // tag="h6"
                            style={{ fontSize: ".8rem", color: "#383838" }}
                            className="mb-3"
                          >
                            {benefit.title}
                          </CardTitle>
                          {/* <CardText className="text-muted">
                    {benefit.description}
                  </CardText> */}
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>

              {/* <div className="col-lg-6 col-md-12 col-sm-12 my-auto">
                <div  className="intro-img text-center"  >
                  <img
                    className="img-fluid"
                    src="/assets/img/search.png"
                    width={'80%'}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BrowseJobs;
